<template>
  <div class="game">
    <Moveable
        ref="yellow"
        class="moveable rate"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updateYellow"
    >
      <img src="@/assets/yellow-bottle.png" width="30px" alt="Rate Indicator">
      <p v-show="pawnFrames[5].isEradicated" class="md-overlay eradicated"><md-icon class="md-primary">not_interested</md-icon></p>
    </Moveable>
    <Moveable
        ref="red"
        class="moveable rate"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updateRed"
    >
      <img src="@/assets/red-bottle.png" width="30px" alt="Rate Indicator">
      <p v-show="pawnFrames[7].isEradicated" class="md-overlay eradicated"><md-icon>not_interested</md-icon></p>
    </Moveable>
    <Moveable
        ref="blue"
        class="moveable rate"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updateBlue"
    >
      <img src="@/assets/blue-bottle.png" width="30px" alt="Rate Indicator">
      <p v-show="pawnFrames[4].isEradicated" class="md-overlay eradicated"><md-icon>not_interested</md-icon></p>
    </Moveable>
    <Moveable
        ref="black"
        class="moveable rate"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updateBlack"
    >
      <img src="@/assets/black-bottle.png" width="30px" alt="Rate Indicator">
      <p v-show="pawnFrames[6].isEradicated" class="md-overlay eradicated"><md-icon>not_interested</md-icon></p>
    </Moveable>
    <Moveable
        ref="rate"
        class="moveable rate"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updateRate"
    >
      <img src="@/assets/rate-indicator.png" width="45px" alt="Rate Indicator">
    </Moveable>
    <Moveable
        ref="outbreaks"
        class="moveable outbreaks-indicator"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updateOutbreaks"
    >
      <img src="@/assets/outbreak-indicator.png" width="45px" alt="Outbreaks Indicator">
    </Moveable>
    <Moveable
      ref="player1"
      class="moveable player1"
      v-bind="moveable"
      @drag="handleDrag"
      @dragEnd="updatePlayer1"
    >
      <img src="@/assets/blue.png" width="30px" alt="Player 1">
      <span class="player">{{players[0].name.substring(0,5)}}</span>
    </Moveable>
    <Moveable
        ref="player2"
        class="moveable player2"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updatePlayer2"
    >
      <img src="@/assets/yellow.png" width="30px" alt="Player 1">
      <span class="player">{{players[1].name.substring(0,5)}}</span>
    </Moveable>
    <Moveable
        ref="player3"
        class="moveable player3"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updatePlayer3"
    >
      <img src="@/assets/red.png" width="30px" alt="Player 1" v-show="gameProgress.numOfPlayers > 2">
      <span class="player">{{players[2].name.substring(0,5)}}</span>
    </Moveable>
    <Moveable
        ref="player4"
        class="moveable player4"
        v-bind="moveable"
        @drag="handleDrag"
        @dragEnd="updatePlayer4"
    >
      <img src="@/assets/green.png" width="30px" alt="Player 1" v-show="gameProgress.numOfPlayers > 3">
      <span class="player">{{players[3].name.substring(0,5)}}</span>
    </Moveable>
    <h1 class="md-accent">Pandemic</h1>
    <div class="game-buttons">
      <div class="md-layout md-alignment-center-space-around">
        <div class="md-layout-item md-layout md-size-100 md-alignment-center-center">
          <div class="md-layout-item md-size-50">
            <md-button class="md-raised md-primary" @click="wantsNewGame = true">
              New Game
            </md-button>
          </div>
          <div class="md-layout-item md-size-50">
            <md-button class="md-raised" @click="dealInfectionCard">
              Deal Infection
            </md-button>
          </div>
        </div>
        <div class="md-layout-item md-layout md-size-100 md-alignment-center-center">
          <div class="md-layout-item md-size-50">
            <md-button class="md-raised" @click="dealCard">
              Deal Card
            </md-button>
          </div>
          <div class="md-layout-item md-size-50">
            <md-button class="md-raised md-accent" @click="readyToIntensify = true">
              Intensify Deck
            </md-button>
          </div>
        </div>
        <div class="md-layout-item md-layout md-size-100 md-alignment-center-center mt-1">
          <div class="md-layout-item md-size-100">
            <h6 class="my-auto">Turn: {{players[gameProgress.currentTurn].name.split(/ (.*)/)[0]}}
              <md-button class="md-icon-button md-dense md-raised turn-button" @click.stop="progressTurn">
                <md-icon>skip_next</md-icon>
              </md-button>
            </h6>
          </div>
        </div>
      </div>
    </div>
    <div class="infection-rate">
      <h4>Infection Rate</h4>
      <img src="@/assets/infection-rate.png" alt="infection rate" width="85%">
    </div>
    <div class="outbreaks">
      <h4>Outbreaks</h4>
      <img src="@/assets/outbreaks.png" alt="outbreaks" width="100%" @dblclick="startApocalypse">
    </div>
    <div class="cured">
      <div class="md-layout md-gutter md-alignment-bottom-center">
        <div class="md-layout-item">
          <img src="@/assets/blue-virus.png" alt="blue virus" @dblclick="pawnFrames[4].isEradicated = !pawnFrames[4].isEradicated">

        </div>
        <div class="md-layout-item">
          <img src="@/assets/yellow-virus.png" alt="yellow virus" @dblclick="pawnFrames[5].isEradicated = !pawnFrames[5].isEradicated">

        </div>
        <div class="md-layout-item">
          <img src="@/assets/black-virus.png" alt="black virus" @dblclick="pawnFrames[6].isEradicated = !pawnFrames[6].isEradicated">

        </div>
        <div class="md-layout-item">
          <img src="@/assets/red-virus.png" alt="red virus" @dblclick="pawnFrames[7].isEradicated = !pawnFrames[7].isEradicated">

        </div>
      </div>
    </div>
    <div class="distribution-map" ref="map">
      <img src="@/assets/map.png" alt="map">
      <button class="map-point" v-for="(point, index) in mapPoints" :key="index" :style="{top: point.yCord, left: point.xCord, background: [point.researchStation ? '#ffffff' : point.color]}" @click="displayCardDialog(index)">
        <div v-show="(point.infectionLevel >= 1)" class="map-point-4"></div>
        <div v-show="(point.infectionLevel >= 2)" class="map-point-4 loc-top"></div>
        <div v-show="(point.infectionLevel === 3)" class="map-point-4 loc-right"></div>
        <span :style="{ margin: '0 0 0 -5px', backgroundColor: [point.color === 'red' || point.researchStation === true ? 'black' : 'red'], position: 'relative', color: 'white' }">{{point.city}}</span>
      </button>
      <md-dialog :md-active.sync="cityInfo" class="text-center">
        <md-dialog-title>
          {{mapPoints[cardIndex].city}}
          <md-button class="md-icon-button md-dense close-dialog" @click="cityInfo=false">
            <md-icon>close</md-icon>
          </md-button>
        </md-dialog-title>
        <md-dialog-content>
          <div class="md-layout md-alignment-center-center">
            <div class="md-layout-item md-size-100">
              <md-button @click="toggleResearchStation" class="md-accent md-raised md-dense"><md-icon>local_hospital</md-icon> Add Research Station</md-button>
            </div>
            <div class="md-layout-item md-layout md-size-100 md-alignment-center-center pt-2">
              <div class="md-layout-item md-size-20">
                <md-button class="md-icon-button md-dense md-raised md-accent infection-button" @click="decreaseInfection">
                  <md-icon>remove</md-icon>
                </md-button>
              </div>
              <div class="md-layout-item md-size-60">
                <p class="dialog-text">
                  Infection Level
                  <br> {{mapPoints[cardIndex].infectionLevel}}
                </p>
              </div>
              <div class="md-layout-item md-size-20">
                <md-button class="md-icon-button md-dense md-raised md-primary infection-button" @click="increaseInfection">
                  <md-icon>add</md-icon>
                </md-button>
              </div>
            </div>
          </div>
        </md-dialog-content>
      </md-dialog>
    </div>
    <div class="connecting-lines" v-for="(line, index) in mapLines" :key="index">
      <svg width="100%" height="100%"><line :x1=line.fromCity.xCord :y1=line.fromCity.yCord :x2=line.toCity.xCord :y2=line.toCity.yCord class="line"/></svg>
    </div>
    <div class="player-profiles">
      <div class="md-layout md-gutter md-alignment-top-center">
        <div v-for="(player, index) in playerProfiles" :key="index" class="md-layout-item">
          <md-card>
            <md-card-header>
              <md-avatar>
                <img :src="require(`@/assets/${player.pawn}`)" alt="Avatar">
              </md-avatar>
              <div class="md-title">{{ player.name }}</div>
              <div class="md-subhead">
                <a @click.stop="() => { showRole = true; roleContent = player.role.description }">{{player.role.title}}</a>
              </div>

            </md-card-header>

            <md-card-expand>
              <md-card-actions class="md-alignment-space-between">
                <div class="md-layout">
                  <div v-for="(card, index) in player.cardsInHand" :key="index" class="card-in-hand">
                    <img v-show="card.color === 'red'" src="@/assets/red-card.png" alt="card" width="12px">
                    <img v-show="card.color === 'blue'" src="@/assets/blue-card.png" alt="card" width="12px">
                    <img v-show="card.color === 'yellow'" src="@/assets/yellow-card.png" alt="card" width="12px">
                    <img v-show="card.color === 'black'" src="@/assets/black-card.png" alt="card" width="12px">
                    <img v-show="card.color === 'orange'" src="@/assets/orange-card.png" alt="card" width="12px">
                  </div>
                </div>

                <md-card-expand-trigger>
                  <md-button class="md-icon-button">
                    <md-icon>keyboard_arrow_down</md-icon>
                  </md-button>
                </md-card-expand-trigger>
              </md-card-actions>

              <md-card-expand-content>
                <md-card-content>
                  <div class="md-layout md-gutter">
                    <Card v-for="(card, index) in player.cardsInHand"
                          :key="index"
                          :cardName="card.city"
                          :cardSubtitle="card.subTitle"
                          :backgroundColor="card.color"
                          :showCardAction="(card.city === 'Resilient Population') || (card.city === 'Forecast')"
                          :showPassingOption="!gameProgress.cardDealt"
                          :showDiscardOption="true"
                          v-on:discard-card="discardCard(player, index)"
                          v-on:pass-to-player="() => {isPassing = true; toPlayer = null; passingPlayer = player; passCardIndex = index}"
                          v-on:card-action="() => {if(card.city === 'Forecast'){gameProgress.playedReorderCard = true;updateFirestoreGameProgress(); updateTopSix()} else {gameProgress.playedRemoveDiscard = true}}"
                          class="md-layout-item md-size-100"
                    ></Card>
                  </div>
                </md-card-content>
              </md-card-expand-content>
            </md-card-expand>
          </md-card>
        </div>

      </div>
    </div>
    <div class="available-actions">
      <md-button class="md-accent md-raised md-dense" @click="showActions = true">Actions</md-button>
    </div>
    <md-dialog :md-active.sync="isPassing">
      <md-dialog-title>
        <h3>Pass to Player:</h3>
        <md-button class="md-icon-button md-dense close-dialog" @click="isPassing=false">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item md-size-100">
            <md-field class="text-center">
              <label for="passTo">Pass to:</label>
              <md-select v-model="toPlayer" name="passTo" id="passTo">
                <md-option
                    v-show="players[0] !== passingPlayer"
                    value="0">{{players[0].name}}</md-option>
                <md-option
                    v-show="players[1] !== passingPlayer"
                    value="1">{{players[1].name}}</md-option>
                <md-option
                    v-show="players[2] !== passingPlayer && players[2].name !== ''"
                    value="2">{{players[2].name}}</md-option>
                <md-option
                    v-show="players[3] !== passingPlayer && players[3].name !== ''"
                    value="3">{{players[3].name}}</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-size-50">
            <md-button
                class="md-primary md-raised"
                @click="passToPlayer(passingPlayer, toPlayer, passCardIndex)">
              Pass
            </md-button>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog :md-active.sync="gameProgress.startingNewGame" class="new-game">
      <md-dialog-title>
        <h3>Let's Get Started!</h3>
        <h3 v-if="playerNamesEntered && !(this.gameProgress.numOfPlayers === this.gameProgress.numOfPlayersSignedUp)">Waiting for other players...</h3>
        <md-button class="md-icon-button md-dense close-dialog" @click="gameProgress.startingNewGame = false">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="md-container">
          <div class="md-layout md-gutter md-alignment-center-center">
            <div class="md-layout-item">
              <p>
                Players Signed Up: {{gameProgress.numOfPlayersSignedUp}}<br>
              </p>
            </div>
            <div class="md-layout-item md-size-100" v-if="!numOfPlayersSigningUp && (gameProgress.numOfPlayers - gameProgress.numOfPlayersSignedUp) > 0">
              <md-field class="text-center">
                <label for="numOfPlayersSigningUp">How many players will play from this screen?</label>
                <md-select v-model.number="numOfPlayersSigningUp">
                  <md-option value="1">1</md-option>
                  <md-option v-if="(gameProgress.numOfPlayers - gameProgress.numOfPlayersSignedUp) > 1" value="2">2</md-option>
                  <md-option v-if="(gameProgress.numOfPlayers - gameProgress.numOfPlayersSignedUp) > 2" value="3">3</md-option>
                  <md-option v-if="(gameProgress.numOfPlayers - gameProgress.numOfPlayersSignedUp) > 3" value="4">4</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-size-100" v-if="numOfPlayersSigningUp && !playerNamesEntered && (gameProgress.numOfPlayers > gameProgress.numOfPlayersSignedUp)">
              <md-field>
                <label>Player 1 Name</label>
                <md-input v-model="players[gameProgress.numOfPlayersSignedUp].name" placeholder="Player 1 Name"></md-input>
              </md-field>
              <md-field v-if="numOfPlayersSigningUp >= 2">
                <label>Player 2 Name</label>
                <md-input v-model="players[gameProgress.numOfPlayersSignedUp + 1].name" placeholder="Player 2 Name"></md-input>
              </md-field>
              <md-field v-if="(numOfPlayersSigningUp >= 3)">
                <label>Player 3 Name</label>
                <md-input v-model="players[gameProgress.numOfPlayersSignedUp + 2].name" placeholder="Player 3 Name"></md-input>
              </md-field>
              <md-field v-if="numOfPlayersSigningUp === 4">
                <label>Player 4 Name</label>
                <md-input v-model="players[gameProgress.numOfPlayersSignedUp + 3].name" placeholder="Player 4 Name"></md-input>
              </md-field>

              <md-button class="md-raised md-primary" @click="addPlayerNames">Ready to go!</md-button>
            </div>
            <div class="md-layout-item md-size-100" v-if="readyToPlay" >
              <div class="md-layout md-gutter" v-for="(player, index) in players" :key="index">
                <div class="md-layout-item">
                  <h3>{{ player.name }}</h3>
                </div>
                <div class="md-layout-item">
                  <h4><em>{{ player.role.title }}</em></h4>
                </div>
              </div>
              <div class="md-layout-item">
                <md-button class="md-raised md-primary" v-show="firstPlayer" @click="startGame">Start the game!</md-button>
              </div>
            </div>
          </div>
        </div>
        <div class="md-overlay md-fixed md-dialog-overlay" v-if="playerNamesEntered && !(this.gameProgress.numOfPlayers === this.gameProgress.numOfPlayersSignedUp)">
          <md-progress-spinner md-mode="indeterminate" class="overlay"></md-progress-spinner>
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog :md-active.sync="gameProgress.cardDealt">
      <md-dialog-title class="text-center">
        <h3>Card dealt to {{gameProgress.lastCardDealTo}}</h3>
        <md-button class="md-icon-button md-dense close-dialog" @click="gameProgress.cardDealt = false">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item md-size-100">
            <Card v-if="gameProgress.lastCardDealt"
                  :cardName="gameProgress.lastCardDealt.city"
                  :cardSubtitle="gameProgress.lastCardDealt.subTitle"
                  :backgroundColor="gameProgress.lastCardDealt.color"
                  :showPassingOption="!gameProgress.cardDealt"
                  v-on:discard-card="() => {gameProgress.cardDealt = false; discardCard(players[gameProgress.currentTurn], 0)}"
                  v-on:pass-to-player="() => {isPassing = true; toPlayer = null; passingPlayer = players[gameProgress.currentTurn]; passCardIndex = 0; gameProgress.cardDealt = false}"
                  class="md-layout-item"
            ></Card>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog :md-active.sync="gameProgress.infectionCardDealt" class="infection-card text-center">
      <md-dialog-title>
        <h3>Infection!!</h3>
        <md-button class="md-icon-button md-dense close-dialog" @click="gameProgress.infectionCardDealt = false">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item md-size-100">
            <Card v-if="gameProgress.lastInfectionCardDealt"
                  :cardName="gameProgress.lastInfectionCardDealt.city"
                  :cardSubtitle="gameProgress.lastInfectionCardDealt.subTitle"
                  :backgroundColor="gameProgress.lastInfectionCardDealt.color"
                  :showCardActiono="false"
                  :showPassingOption="false"
                  :showDiscardOption="false"
                  class="md-layout-item"
            ></Card>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog :md-active.sync="gameProgress.playedReorderCard">
      <md-dialog-title>
        <h3>Re-Order Top 6 Infection Cards</h3>
        <small>Only one player needs to 're-order'</small>
        <md-button class="md-icon-button md-dense close-dialog" @click="gameProgress.playedReorderCard = false">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-alignment-center-center">
          <div class="md-layout-item md-size-90">
            <draggable :forceFallback="true" :list="deckToReorder" :move="checkMove" ghost-class="ghost" @start="isDragging=true" @end="isDragging=false">

              <div class="list-group-item" v-for="card in deckToReorder" :key="card.deckOrder">
                <Card
                    :cardName="card.city"
                    :backgroundColor="card.color"
                    :showPassingOption="false"
                    :showDiscardOption="false"
                    :showCardAction="false"
                    class="md-layout-item"
                ></Card>
              </div>

            </draggable>
          </div>
          <div class="md-layout-item md-size-50">
            <md-button class="md-raised md-dense md-primary" @click="reOrderCards">Re-Order</md-button>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog :md-active.sync="gameProgress.playedRemoveDiscard">
      <md-dialog-title>
        <div v-if="discardedInfectionDeck.length !== 0">
          <h3>Select One Card to Remove From Game</h3>
          <small>Card will be removed on click</small>
        </div>
        <h5 v-else>There are no cards in the Discard Pile</h5>
        <md-button class="md-icon-button md-dense close-dialog" @click="gameProgress.playedRemoveDiscard = false">
          <md-icon>close</md-icon>
        </md-button>
      </md-dialog-title>
      <md-dialog-content>
        <div class="md-layout md-alignment-center-center">
          <div class="md-layout-item md-size-90">

            <div class="list-group-item" v-for="card in discardedInfectionDeck" :key="card.deckOrder">
              <Card
                :cardName="card.city"
                :backgroundColor="card.color"
                :showPassingOption="false"
                :showDiscardOption="false"
                :showCardAction="false"
                v-on:card-selected="discardedCardSelected(card)"
                class="md-layout-item"
              ></Card>
            </div>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog-confirm
        :md-active.sync="wantsNewGame"
        md-title="Start New Game?"
        md-content="All current game progress will be lost."
        md-confirm-text="Yes!"
        md-cancel-text="Cancel"
        @md-cancel="wantsNewGame = false"
        @md-confirm="newGame" />
    <md-dialog-confirm
        :md-active.sync="readyToIntensify"
        md-title="Intensify the Infection Deck?!"
        md-content="This cannot be undone"
        md-confirm-text="Here we go!"
        md-cancel-text="Cancel"
        @md-cancel="readyToIntensify = false"
        @md-confirm="intensifyInfectionDeck" />

    <md-dialog-alert
        :md-active.sync="showRole"
        :md-content="roleContent"
        md-confirm-text="Cool"
    />
    <md-dialog-alert
        :md-active.sync="showActions"
        md-content="
        <h2>Drive/Ferry</h2>
        <p>Move to a city connected by a white line</p>
        <h2>Direct Flight</h2>
        <p>Discard a City card to move to the city named on the card</p>
        <h2>Charter Flight</h2>
        <p>Discard the City card that <em>matches</em> the city you are in to move to <em>any</em> city.</p>
        <h2>Shuttle Flight</h2>
        <p>Move from a city with a research station to any other city that has a research station</p>
        <h2>Build a Research Station</h2>
        <p>Discard teh City card that <em>matches</em> the city you are in to place a research station there</p>
        <h2>Treat Disease</h2>
        <p>Remove 1 disease cube from the city you are in. If this color is <em>cured</em>, remove all cubes <em>of that color</em> from the city</p>
        <h2>Share Knowledge</h2>
        <p>Either: <em>give</em> the card that <em>matches</em> the city you are in to another player, or <em>take</em> that card from another player. The other player must also be in teh city with you.</p>
        <h2>Discover a Cure</h2>
        <p>At <em>any</em> research station, discard 5 City cards of the same disease color to cure that disease.</p>"
        md-confirm-text="Cool"
    />
    <div class="md-overlay md-fixed md-dialog-overlay" v-if="gameProgress.isApocalypse" style="z-index: 1200">
      <img src="@/assets/skull.png" alt="skull">
    </div>
  </div>
</template>

<script>
  import Moveable from "vue-moveable"
  import Card from "@/components/Card.vue"
  import db from '@/firebase/init'
  import {Frame} from 'scenejs'
  import draggable from 'vuedraggable'

  export default {
    name: "Game",
    components: {
      Moveable,
      Card,
      draggable
    },
    data(){
      return {
        gameProgress: {
          playedReorderCard: false,
          infectionCardDealt: false,
          lastInfectionCardDealt: null,
          isApocalypse: false,
          cardsDealtToPlayer: 0,
          lastCardDealTo: '',
          playedRemoveDiscard: false,
          discardedCardToRemove: null,
          secondDiscardedCardToRemove: null,
          numOfDiscardedCardsRemoved: 0,
          startingNewGame: true,
          numOfPlayers: null,
          cardDealt: false,
          lastCardDealt: null,
          currentTurn: 0,
          numOfEpidemicCards: null,
          numOfPlayersSignedUp: 0
        },
        firstPlayer: false,
        readyToIntensify: false,
        firestoreCollection: this.$route.params.url,
        numOfPlayersSigningUp: null,
        playerNamesEntered: false,
        cityInfo: false,
        isOutbreak: false,
        isPassing: false,
        cardDealt: false,
        showRole: false,
        showActions: false,
        wantsNewGame: false,
        animation: 0,
        isDragging: false,
        delayedDragging: false,
        roleContent: null,
        lastCardDealt: null,
        passCardIndex: null,
        passingPlayer: null,
        toPlayer: null,
        cardIndex: 0,
        moveable: {
          draggable: true,
          throttleDrag: 1,
          resizable: false,
          throttleResize: 1,
          keepRatio: false,
          scalable: false,
          throttleScale: 0.01,
          rotatable: false,
          throttleRotate: 0.2,
          pinchable: false,
          origin: false
        },
        pawnFrames: [
          {
            piece: 'player1',
            frame: {
              width: '40px',
              height: '70px',
              left: '40%',
              top: '5%',
            }
          },
          {
            piece: 'player2',
            frame: {
              width: '40px',
              height: '70px',
              left: '45%',
              top: '5%',
            }
          },
          {
            piece: 'player3',
            frame: {
              width: '40px',
              height: '70px',
              left: '50%',
              top: '5%',
            }
          },
          {
            piece: 'player4',
            frame: {
              width: '40px',
              height: '70px',
              left: '55%',
              top: '5%',
            }
          },
          {
            piece: 'blue',
            frame: {
              width: '40px',
              height: '70px',
              left: '58.5%',
              top: '94%'
            },
            isEradicated: false
          },
          {
            piece: 'yellow',
            frame: {
              width: '40px',
              height: '70px',
              left: '64%',
              top: '94%'
            },
            isEradicated: false
          },
          {
            piece: 'black',
            frame: {
              width: '40px',
              height: '70px',
              left: '69.5%',
              top: '94%'
            },
            isEradicated: false
          },
          {
            piece: 'red',
            frame: {
              width: '40px',
              height: '70px',
              left: '75.5%',
              top: '94%'
            },
            isEradicated: false
          },
          {
            piece: 'outbreaks',
            frame: {
              width: '40px',
              height: '40px',
              left: '6%',
              top: '61%',
            }
          },
          {
            piece: 'rate',
            frame: {
              width: '40px',
              height: '40px',
              left: '73.5%',
              top: '7.5%',
            }
          }
        ],
        currentTurn: 0,
        players: [
          {
            name: '',
            role: {
              title: '',
              description: ''
            },
            pawn: 'blue.png',
            id: 'player1',
            cardsInHand: []
          },
          {
            name: '',
            role: {
              title: '',
              description: ''
            },
            pawn: 'yellow.png',
            id: 'player2',
            cardsInHand: []
          },
          {
            name: '',
            role: {
              title: '',
              description: ''
            },
            pawn: 'red.png',
            id: 'player3',
            cardsInHand: []
          },
          {
            name: '',
            role: {
              title: '',
              description: ''
            },
            pawn: 'green.png',
            id: 'player4',
            cardsInHand: []
          }
        ],
        window: {
          width: 0,
          height: 0
        },
        mapPoints: [
          {
            city: 'Los Angeles',
            xCord: '16%',
            yCord: '45%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Miami',
            xCord: '26%',
            yCord: '50%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Mexico City',
            xCord: '20%',
            yCord: '55%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Bogota',
            xCord: '29%',
            yCord: '62%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Lima',
            xCord: '26%',
            yCord: '75%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Santiago',
            xCord: '25%',
            yCord: '87%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Buenos Aires',
            xCord: '33%',
            yCord: '83%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Sao Paulo',
            xCord: '37%',
            yCord: '71%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Lagos',
            xCord: '46%',
            yCord: '58%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Kinshasa',
            xCord: '51%',
            yCord: '67%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Johannesburg',
            xCord: '54%',
            yCord: '80%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Khartoum',
            xCord: '56%',
            yCord: '60%',
            color: 'yellow',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'San Francisco',
            xCord: '14%',
            yCord: '37%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Chicago',
            xCord: '19%',
            yCord: '32%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Atlanta',
            xCord: '22%',
            yCord: '41%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: true,
            dealtOut: false
          },
          {
            city: 'Montreal',
            xCord: '26%',
            yCord: '32%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Washington',
            xCord: '30%',
            yCord: '44%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'New York',
            xCord: '32%',
            yCord: '35%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Madrid',
            xCord: '42%',
            yCord: '43%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'London',
            xCord: '43%',
            yCord: '30%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Essen',
            xCord: '49%',
            yCord: '25%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Paris',
            xCord: '46%',
            yCord: '38%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Milan',
            xCord: '50%',
            yCord: '35%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'St. Petersburg',
            xCord: '54%',
            yCord: '20%',
            color: 'blue',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Moscow',
            xCord: '59%',
            yCord: '28%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Istanbul',
            xCord: '54%',
            yCord: '38%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Algiers',
            xCord: '47%',
            yCord: '47%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Cairo',
            xCord: '53%',
            yCord: '48%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Baghdad',
            xCord: '59%',
            yCord: '43%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Tehran',
            xCord: '65%',
            yCord: '33%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Karachi',
            xCord: '65%',
            yCord: '44%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Riyadh',
            xCord: '59%',
            yCord: '53%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Mumbai',
            xCord: '65%',
            yCord: '56%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Delhi',
            xCord: '70%',
            yCord: '40%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Chennai',
            xCord: '68%',
            yCord: '63%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Kolkata',
            xCord: '71%',
            yCord: '51%',
            color: 'black',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Bangkok',
            xCord: '73.5%',
            yCord: '60%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Hong Kong',
            xCord: '75%',
            yCord: '47%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Shanghai',
            xCord: '74%',
            yCord: '36%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Beijing',
            xCord: '76%',
            yCord: '27%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Seoul',
            xCord: '81%',
            yCord: '33%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Tokyo',
            xCord: '85%',
            yCord: '39%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Osaka',
            xCord: '85%',
            yCord: '47%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Taipei',
            xCord: '81%',
            yCord: '52%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Ho Chi Minh City',
            xCord: '78%',
            yCord: '60%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Manila',
            xCord: '84%',
            yCord: '61%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Jakarta',
            xCord: '76%',
            yCord: '70%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'Sydney',
            xCord: '86%',
            yCord: '82%',
            color: 'red',
            infectionLevel: 0,
            researchStation: false,
            dealtOut: false
          },
          {
            city: 'To LA',
            xCord: '99%',
            yCord: '80%',
            color: 'transparent',
            infectionLevel: 0,
            researchStation: false
          },
          {
            city: 'To SF',
            xCord: '99%',
            yCord: '55%',
            color: 'transparent',
            infectionLevel: 0,
            researchStation: false
          },
          {
            city: 'To SF2',
            xCord: '99%',
            yCord: '40%',
            color: 'transparent',
            infectionLevel: 0,
            researchStation: false
          },
          {
            city: 'To Tokyo',
            xCord: '1%',
            yCord: '35%',
            color: 'transparent',
            infectionLevel: 0,
            researchStation: false
          },
          {
            city: 'To Manila',
            xCord: '1%',
            yCord: '43%',
            color: 'transparent',
            infectionLevel: 0,
            researchStation: false
          },
          {
            city: 'To Sydney',
            xCord: '1%',
            yCord: '60%',
            color: 'transparent',
            infectionLevel: 0,
            researchStation: false
          }
        ],
        mapLines: [],
        fullDeck: [
          {
            city: 'Los Angeles',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Miami',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Mexico City',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Bogota',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Lima',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Santiago',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Buenos Aires',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Sao Paulo',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Lagos',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Kinshasa',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Johannesburg',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Khartoum',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'San Francisco',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Chicago',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Atlanta',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Montreal',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Washington',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'New York',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Madrid',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'London',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Essen',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Paris',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Milan',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'St. Petersburg',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Moscow',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Istanbul',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Algiers',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Cairo',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Baghdad',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Tehran',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Karachi',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Riyadh',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Mumbai',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Delhi',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Chennai',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Kolkata',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Bangkok',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Hong Kong',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Shanghai',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Beijing',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Seoul',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Tokyo',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Osaka',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Taipei',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Ho Chi Minh City',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Manila',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Jakarta',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Sydney',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Resilient Population',
            subTitle: 'Remove any 1 card in the Infection Discard Pile.',
            color: 'orange',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'One Quiet Night',
            subTitle: 'Skip the next Infect Cities Step.',
            color: 'orange',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Forecast',
            subTitle: 'Rearrange the top 6 cards of the infection deck. Put them back on top.',
            color: 'orange',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Government Grant',
            subTitle: 'Add 1 research station to any city (no city card needed).',
            color: 'orange',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Airlift',
            subTitle: 'Move any 1 pawn to any city.',
            color: 'orange',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Epidemic #1',
            subTitle: '(1) Increase Infection Rate (2) Infect Bottom Card (3) Intensify (Reshuffle discard pile)',
            color: 'green',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Epidemic #2',
            subTitle: '(1) Increase Infection Rate (2) Infect Bottom Card (3) Intensify (Reshuffle discard pile)',
            color: 'green',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Epidemic #3',
            subTitle: '(1) Increase Infection Rate (2) Infect Bottom Card (3) Intensify (Reshuffle discard pile)',
            color: 'green',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Epidemic #4',
            subTitle: '(1) Increase Infection Rate (2) Infect Bottom Card (3) Intensify (Reshuffle discard pile)',
            color: 'green',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Epidemic #5',
            subTitle: '(1) Increase Infection Rate (2) Infect Bottom Card (3) Intensify (Reshuffle discard pile)',
            color: 'green',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Epidemic #6',
            subTitle: '(1) Increase Infection Rate (2) Infect Bottom Card (3) Intensify (Reshuffle discard pile)',
            color: 'green',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          }
        ],
        infectionDeck: [
          {
            city: 'Los Angeles',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Miami',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Mexico City',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Bogota',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Lima',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Santiago',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Buenos Aires',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Sao Paulo',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Lagos',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Kinshasa',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Johannesburg',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Khartoum',
            subTitle: '.',
            color: 'yellow',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'San Francisco',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Chicago',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Atlanta',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Montreal',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Washington',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'New York',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Madrid',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'London',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Essen',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Paris',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Milan',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'St. Petersburg',
            subTitle: '.',
            color: 'blue',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Moscow',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Istanbul',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Algiers',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Cairo',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Baghdad',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Tehran',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Karachi',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Riyadh',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Mumbai',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Delhi',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Chennai',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Kolkata',
            subTitle: '.',
            color: 'black',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Bangkok',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Hong Kong',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Shanghai',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Beijing',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Seoul',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Tokyo',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Osaka',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Taipei',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Ho Chi Minh City',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Manila',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Jakarta',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          },
          {
            city: 'Sydney',
            subTitle: '.',
            color: 'red',
            dealtOut: false,
            discarded: false,
            deckOrder: 0
          }
        ],
        rolesAssigned: false,
        numOfEpidemicCards: 4,
        roles: [
          {
            title: 'Operations Expert',
            description: 'As an action, build a research station in the city you are in (no City card needed). Once per turn as an action, move from a research station to any city by discarding any City card.'
          },
          {
            title: 'Quarantine Specialist',
            description: 'Prevent disease cube placements (and outbreaks) in the city you are in and all cities connected to it.'
          },
          {
            title: 'Contingency Planner',
            description: 'As an action, take any discarded Event card and store it on this card. When you play the stored Event card, remove it from the game. Limit 1 card at a time'
          },
          {
            title: 'Scientist',
            description: 'You need only 4 cards ofo teh same color to do the Discover a Cure action'
          },
          {
            title: 'Medic',
            description: 'Remove all cubes of one color when doing Treat Disease. Automatically remove cubes of cured diseases from the city you are in (and prevent them from being placed there).'
          }
          ,
          {
            title: 'Researcher',
            description: 'You may give any 1 of your City cards when you Share Knowledge. It need not match your city. A player who Shares Knowledge with you on their turn can take any 1 of your City cards'
          }
          ,
          {
            title: 'Dispatcher',
            description: 'Move another players pawn as if it were yours. As an action, move any pawn to a city with another pawn.'
          }
          ],
        deckToReorder: []
      }
    },
    computed: {
      newGameDeck(){
        var newArray = Array.from(this.fullDeck);
        var splicedArray = newArray.splice(0, 53);
        for (let i = splicedArray.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          [splicedArray[i], splicedArray[j]] = [splicedArray[j], splicedArray[i]];
        }
        return splicedArray.filter(card =>{
          return !card.dealtOut
        })
      },
      cardDeck(){
        var newArray = Array.from(this.fullDeck);
        var deckWithEpidemics = newArray.splice(0, (53 + this.gameProgress.numOfEpidemicCards));

        this.shuffleCards(deckWithEpidemics);
        return deckWithEpidemics.filter(card =>{
          return !card.dealtOut
        })
      },
      nonDiscardedInfectionDeck(){
        return this.infectionDeck.filter(card =>{
          return !card.discarded && (card.city !== this.gameProgress.discardedCardToRemove.city) && (card.city !== this.gameProgress.secondDiscardedCardToRemove.city)
        })
      },
      discardedInfectionDeck(){
        return this.infectionDeck.filter(card =>{
          return card.discarded && (card.city !== this.gameProgress.discardedCardToRemove.city) && (card.city !== this.gameProgress.secondDiscardedCardToRemove.city)
        })
      },
      playedReorderCard(){
        return this.gameProgress.playedReorderCard
      },
      playerProfiles(){
        return this.players.filter((player, i)=>{
          return i <= (this.gameProgress.numOfPlayers - 1)
        })
      },
      readyToPlay(){
        return (this.gameProgress.numOfPlayers === this.gameProgress.numOfPlayersSignedUp)
      },
      player1Position(){
        let frame = new Frame(this.pawnFrames[0].frame);
        return frame.toCSS()
      },
      player2Position(){
        let frame = new Frame(this.pawnFrames[1].frame);
        return frame.toCSS()
      },
      player3Position(){
        let frame = new Frame(this.pawnFrames[2].frame);
        return frame.toCSS()
      },
      player4Position(){
        let frame = new Frame(this.pawnFrames[3].frame);
        return frame.toCSS()
      },
      bluePosition(){
        let frame = new Frame(this.pawnFrames[4].frame);
        return frame.toCSS()
      },
      yellowPosition(){
        let frame = new Frame(this.pawnFrames[5].frame);
        return frame.toCSS()
      },
      blackPosition(){
        let frame = new Frame(this.pawnFrames[6].frame);
        return frame.toCSS()
      },
      redPosition(){
        let frame = new Frame(this.pawnFrames[7].frame);
        return frame.toCSS()
      },
      outbreaksPosition(){
        let frame = new Frame(this.pawnFrames[8].frame);
        return frame.toCSS()
      },
      ratePosition(){
        let frame = new Frame(this.pawnFrames[9].frame);
        return frame.toCSS()
      }
    },
    methods: {
      shuffleCards(deck){
        for (let i = deck.length - 1; i > 0; i--){
          let j = Math.floor(Math.random() * (i + 1));
          [deck[i], deck[j]] = [deck[j], deck[i]];
        }
      },
      getObjectByCityName(city) {
        return this.mapPoints.filter(point => {
          return point.city === city
        })
      },
      handleDrag({ target, transform }) {
        target.style.transform = transform;
      },
      checkMove(e) {
        window.console.log("Future index: " + e.draggedContext.futureIndex);
      },
      reOrderCards(){
        this.deckToReorder.forEach((card, i) => {
          card.deckOrder = i;
          this.updateFirestoreInfectionData(card)
        });
        this.gameProgress.playedReorderCard = false;
        this.updateFirestoreGameProgress()
      },
      discardedCardSelected(card){
        if (this.gameProgress.numOfDiscardedCardsRemoved === 0){
          this.gameProgress.discardedCardToRemove = card;
          this.gameProgress.numOfDiscardedCardsRemoved ++
        } else {
          this.gameProgress.secondDiscardedCardToRemove = card
        }
        this.gameProgress.playedRemoveDiscard = false
        this.updateFirestoreGameProgress()
      },
      updatePlayer1(){
        let top = (this.$refs.player1.getRect().top - (2*this.$refs.player1.getRect().height/3 * this.$refs.player1.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[0].frame.left = this.$refs.player1.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[0].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[0]);
      },
      updatePlayer2(){
        let top = (this.$refs.player2.getRect().top - (3*this.$refs.player2.getRect().height/4 * this.$refs.player2.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[1].frame.left = this.$refs.player2.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[1].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[1]);
      },
      updatePlayer3(){
        let top = (this.$refs.player3.getRect().top - (3*this.$refs.player3.getRect().height/4 * this.$refs.player3.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[2].frame.left = this.$refs.player3.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[2].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[2]);
      },
      updatePlayer4(){
        let top = (this.$refs.player4.getRect().top - (3*this.$refs.player4.getRect().height/4 * this.$refs.player4.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[3].frame.left = this.$refs.player4.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[3].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[3]);
      },
      updateBlack(){
        let top = (this.$refs.black.getRect().top - (3*this.$refs.black.getRect().height/4 * this.$refs.black.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[6].frame.left = this.$refs.black.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[6].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[6]);
      },
      updateRed(){
        let top = (this.$refs.red.getRect().top - (3*this.$refs.red.getRect().height/4 * this.$refs.red.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[7].frame.left = this.$refs.red.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[7].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[7]);
      },
      updateYellow(){
        let top = (this.$refs.yellow.getRect().top - (3*this.$refs.yellow.getRect().height/4 * this.$refs.yellow.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[5].frame.left = this.$refs.yellow.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[5].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[5]);
      },
      updateBlue(){
        let top = (this.$refs.blue.getRect().top - (3*this.$refs.blue.getRect().height/4 * this.$refs.blue.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[4].frame.left = this.$refs.blue.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[4].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[4]);
      },
      updateOutbreaks(){
        let top = (this.$refs.outbreaks.getRect().top - (3*this.$refs.outbreaks.getRect().height/4 * this.$refs.outbreaks.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[8].frame.left = this.$refs.outbreaks.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[8].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[8]);
      },
      updateRate(){
        let top = (this.$refs.rate.getRect().top - (3*this.$refs.rate.getRect().height/4 * this.$refs.rate.getRect().top / this.window.height))/this.window.height
        this.pawnFrames[9].frame.left = this.$refs.rate.getRect().left * 100 / this.window.width + '%';
        this.pawnFrames[9].frame.top = top*100 + '%';

        this.updateFirestorePawnData(this.pawnFrames[9]);
      },
      handleResize(){
        this.window.width = window.innerWidth;
        this.window.height = this.$refs.map.clientHeight;
      },
      discardCard(player, index){
        player.cardsInHand.splice(index, 1)
      },
      passToPlayer(passingPlayer, toPlayer, index){
        let player = this.players[toPlayer];
        player.cardsInHand.push(passingPlayer.cardsInHand[index]);
        passingPlayer.cardsInHand.splice(index, 1);
        this.isPassing = false;
        this.updateFirestorePlayerData(passingPlayer);
        this.updateFirestorePlayerData(this.players[toPlayer]);
      },
      displayCardDialog(index){
        this.cityInfo = true;
        this.cardIndex = index
      },
      addPlayerNames(){
        var playersProcessed = 0;
        if(this.gameProgress.numOfPlayersSignedUp === 0){
          this.firstPlayer = true
        }
        this.players.forEach(player => {
          if (player.name && this.players.findIndex(signingUpPlayer => signingUpPlayer.name === player.name) >= this.gameProgress.numOfPlayersSignedUp){
            this.updateFirestorePlayerData(player);
            this.gameProgress.numOfPlayersSignedUp++
          }
          playersProcessed++;
          if (playersProcessed === this.players.length){
            this.updateFirestoreGameProgress();
            this.playerNamesEntered = true
          }
        });
        if(this.gameProgress.numOfPlayers === this.gameProgress.numOfPlayersSignedUp){
          this.assignRoles();
        }
      },
      assignRoles(){
        var remainingRoles = this.roles;
        this.players.forEach((player, i) => {
          if(i < this.gameProgress.numOfPlayers){
            let x = Math.floor(Math.random() * (7 - i));
            player.role =  remainingRoles.splice(x, 1)[0];
            this.updateFirestorePlayerData(player)
          }
        });
        this.rolesAssigned = true
      },
      async dealCard(){
        if(this.cardDeck.length === 0){
          this.startApocalypse()
        } else {
          if(this.cardDeck[0].color !== 'green'){
            this.gameProgress.lastCardDealTo = this.players[this.gameProgress.currentTurn].name
            this.players[this.gameProgress.currentTurn].cardsInHand.push(this.cardDeck[0]);
            this.updateFirestorePlayerData(this.players[this.gameProgress.currentTurn]);
          }
          this.gameProgress.lastCardDealt = this.cardDeck[0];
          await this.updateCardInfo();
          this.updateFirestoreCardData(this.gameProgress.lastCardDealt);
          this.gameProgress.cardDealt = true;
          this.updateFirestoreGameProgress();
        }
        if(this.gameProgress.cardsDealtToPlayer === 1){
          this.progressTurn()
        } else {
          this.gameProgress.cardsDealtToPlayer = 1
          this.updateFirestoreGameProgress()
        }
      },
      updateCardInfo(){
        this.cardDeck[0].dealtOut = true;
      },
      dealInfectionCard(){
        var sortedArray = this.nonDiscardedInfectionDeck.sort((card1, card2) => {
          return card1.deckOrder - card2.deckOrder
        });
        sortedArray[0].discarded = true
        this.updateFirestoreInfectionData(sortedArray[0])
        this.gameProgress.lastInfectionCardDealt = sortedArray[0]
        this.gameProgress.infectionCardDealt = true
        this.updateFirestoreGameProgress()
      },
      intensifyInfectionDeck(){
        let lastCard = this.nonDiscardedInfectionDeck.find(card => card.deckOrder === 47);
        let cityToInfect = this.mapPoints.find(point => point.city === lastCard.city);
        cityToInfect.infectionLevel = 3;
        this.updateFirestoreCityData(cityToInfect);
        this.gameProgress.lastInfectionCardDealt = lastCard
        this.gameProgress.infectionCardDealt = true
        this.nonDiscardedInfectionDeck.forEach(card => {
          card.deckOrder++
          this.updateFirestoreInfectionData(card)
        });

        var newArray = Array.from(this.discardedInfectionDeck);
        newArray.push(lastCard)
        this.shuffleCards(newArray)

        newArray.forEach((card, i) => {
          card.deckOrder = i
          card.discarded = false
          this.updateFirestoreInfectionData(card)
        })
      },
      updateTopSix(){
        var newArray = Array.from(this.nonDiscardedInfectionDeck);
        this.deckToReorder = newArray.sort((card1, card2) => {
          return card1.deckOrder - card2.deckOrder
        }).splice(0, 6)
      },
      toggleResearchStation(){
        if (this.mapPoints && this.cardIndex){
          this.mapPoints[this.cardIndex].researchStation = !this.mapPoints[this.cardIndex].researchStation;
          db.collection('games')
            .doc(this.firestoreCollection)
            .collection('cities')
            .doc(this.mapPoints[this.cardIndex].city)
            .set(this.mapPoints[this.cardIndex], { merge: true });
        }
      },
      decreaseInfection(){
        if (this.mapPoints[this.cardIndex].infectionLevel > 0) {
          this.mapPoints[this.cardIndex].infectionLevel --;
          this.updateFirestoreCityData(this.mapPoints[this.cardIndex]);
        }
      },
      increaseInfection(){
        if (this.mapPoints[this.cardIndex].infectionLevel < 3) {
          this.mapPoints[this.cardIndex].infectionLevel ++;
          this.updateFirestoreCityData(this.mapPoints[this.cardIndex]);
        }
      },
      updateFirestoreCityData(city){
        db.collection('games')
          .doc(this.firestoreCollection)
          .collection('cities')
          .doc(city.city)
          .set(city, { merge: true });
      },
      updateFirestorePlayerData(player){
        db.collection('games').doc(this.firestoreCollection)
          .collection('players').doc(player.id)
          .set(player, { merge: true});
      },
      updateFirestorePawnData(pawn){
        db.collection('games').doc(this.firestoreCollection)
          .collection('pawnPositions').doc(pawn.piece)
          .set(pawn, { merge: true});
      },
      updateFirestoreCardData(card){
        db.collection('games').doc(this.firestoreCollection)
          .collection('cardDeck').doc(card.city)
          .set(card, { merge: true });
      },
      updateFirestoreInfectionData(card){
        db.collection('games').doc(this.firestoreCollection)
        .collection('infectionDeck').doc(card.city)
        .set(card, { merge: true });
      },
      updateFirestoreGameProgress(){
        db.collection('games').doc(this.firestoreCollection).collection('gameProgress').doc('data').set(this.gameProgress, { merge: true })
      },
      progressTurn(){
        this.gameProgress.cardsDealtToPlayer = 0
        this.gameProgress.currentTurn < (this.gameProgress.numOfPlayers - 1) ? this.gameProgress.currentTurn ++ : this.gameProgress.currentTurn = 0;
        this.updateFirestoreGameProgress();
      },
      setCardDeck(){
        let cardDeckRef = db.collection('games').doc(this.firestoreCollection).collection('cardDeck')
        this.cardDeck.forEach((card) => {
          cardDeckRef.doc(card.city).set(card)
        })
      },
      setInfectionDeck(){
        var infectionRef = db.collection('games').doc(this.firestoreCollection).collection('infectionDeck')
        var newArray = Array.from(this.fullDeck);
        var onlyCities = newArray.splice(0, 48);
        for (let i = onlyCities.length - 1; i > 0; i-- ){
          let j = Math.floor(Math.random() * (i + 1));
          [onlyCities[i], onlyCities[j]] = [onlyCities[j], onlyCities[i]];
        }
        onlyCities.forEach((card, i) => {
          card.deckOrder = i
          infectionRef.doc(card.city).set(card)
        })
      },
      async dealCardGameStart(player){
        Array.prototype.push.apply(player.cardsInHand, this.newGameDeck.slice(0,1))
        this.updateFirestorePlayerData(player)
        this.updateFirestoreCardData({
          city: this.newGameDeck[0].city,
          color: this.newGameDeck[0].color,
          dealtOut: true,
          subTitle: this.newGameDeck[0].subTitle
        })
        this.newGameDeck[0].dealtOut = true
      },
      newGame(){
        this.$router.push('/')
      },
      async startGame(){
        if(this.gameProgress.numOfPlayers === this.gameProgress.numOfPlayersSignedUp){
          for (const player of this.players) {
            if(player.name !== ''){
              if(this.gameProgress.numOfPlayers === 2){
                await this.dealCardGameStart(player)
                await this.dealCardGameStart(player)
                await this.dealCardGameStart(player)
                await this.dealCardGameStart(player)
              } else if(this.gameProgress.numOfPlayers === 3){
                await this.dealCardGameStart(player)
                await this.dealCardGameStart(player)
                await this.dealCardGameStart(player)
              } else {
                await this.dealCardGameStart(player)
                await this.dealCardGameStart(player)
              }
            }
          }

          this.infectionDeck.forEach(city => {
            if(city.deckOrder < 3){
              let cityToInfect = this.mapPoints.find(point => point.city === city.city);
              cityToInfect.infectionLevel = 3;
              city.discarded = true;
              this.updateFirestoreCityData(cityToInfect);
              this.updateFirestoreInfectionData(city)
            } else if(city.deckOrder < 6){
              let cityToInfect = this.mapPoints.find(point => point.city === city.city);
              cityToInfect.infectionLevel = 2;
              city.discarded = true;
              this.updateFirestoreCityData(cityToInfect);
              this.updateFirestoreInfectionData(city)
            } else if(city.deckOrder < 9){
              let cityToInfect = this.mapPoints.find(point => point.city === city.city);
              cityToInfect.infectionLevel = 1;
              city.discarded = true;
              this.updateFirestoreCityData(cityToInfect);
              this.updateFirestoreInfectionData(city)
            }
          });
          this.gameProgress.startingNewGame = false;
          this.updateFirestoreGameProgress();
        }
      },
      startApocalypse(){
        this.gameProgress.isApocalypse = true;
        this.updateFirestoreGameProgress()
      }
    },
    watch:{
      playedReorderCard: {
        handler: function(){
          this.updateTopSix()
        }
  }
    },
    updated(){
      this.$refs.player1.moveable.target.style.cssText = this.player1Position;
      this.$refs.player2.moveable.target.style.cssText = this.player2Position;
      this.$refs.player3.moveable.target.style.cssText = this.player3Position;
      this.$refs.player4.moveable.target.style.cssText = this.player4Position;
      this.$refs.yellow.moveable.target.style.cssText = this.yellowPosition;
      this.$refs.blue.moveable.target.style.cssText = this.bluePosition;
      this.$refs.red.moveable.target.style.cssText = this.redPosition;
      this.$refs.black.moveable.target.style.cssText = this.blackPosition;
      this.$refs.outbreaks.moveable.target.style.cssText = this.outbreaksPosition;
      this.$refs.rate.moveable.target.style.cssText = this.ratePosition;
      if(this.window.height < 150){
        this.handleResize();
      }
    },
    created(){
      let gameRef = db.collection('games').doc(this.firestoreCollection);
      let cityRef = gameRef.collection('cities');
      let cardDeckRef = gameRef.collection('cardDeck');
      let pawnPositionsRef = gameRef.collection('pawnPositions');
      let playersRef = gameRef.collection('players');
      let gameProgressRef = gameRef.collection('gameProgress');
      let infectionDeckRef = gameRef.collection('infectionDeck');

      cityRef.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type !== 'removed' ){
            let doc = change.doc;
            let changedCityIndex = this.mapPoints
              .findIndex(city => city.city === doc.data().city);
            this.mapPoints.splice(changedCityIndex, 1, doc.data())
          }
        })
      });

      playersRef.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type !== 'removed'){
            let doc = change.doc;
            let changedPlayerIndex = this.players
              .findIndex(player => player.id === doc.data().id);
            this.players.splice(changedPlayerIndex, 1, doc.data());
          }
        })
      });

      pawnPositionsRef.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type !== 'removed'){
            let doc = change.doc;
            let changedPawn = this.pawnFrames
              .findIndex(pawn => pawn.piece === doc.data().piece);
            this.pawnFrames.splice(changedPawn, 1, doc.data());
          }
        })
      });

      cardDeckRef.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type !== 'removed'){
            let doc = change.doc;
            let cardChanged = this.fullDeck
              .findIndex(card => card.city === doc.data().city);
            this.fullDeck.splice(cardChanged, 1, doc.data());
          }
        })
      });

      infectionDeckRef.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type !== 'removed'){
            let doc = change.doc;
            let cardChangedIndex = this.infectionDeck.findIndex(card => card.city === doc.data().city);
            this.infectionDeck.splice(cardChangedIndex, 1, doc.data());
          } else if(change.type === 'removed'){
            let deletedDoc = change.doc;
            let deletedCardIndex = this.infectionDeck.findIndex(card => card.city === deletedDoc.data().city);
            this.infectionDeck.splice(deletedCardIndex, 1)
          }
        })
      });

      gameProgressRef.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type !== 'removed'){
            let doc = change.doc;
            if(doc.data().numOfPlayersSignedUp === 0){
              this.setCardDeck();
              this.setInfectionDeck();
            }
            console.log(doc.data())
            this.gameProgress = doc.data();
          }
        })
      })
    },
    mounted(){
      window.addEventListener('resize', this.handleResize);
      this.mapLines = [
          {
            fromCity: this.getObjectByCityName('Los Angeles')[0],
            toCity: this.getObjectByCityName('Chicago')[0]
          },
          {
            fromCity: this.getObjectByCityName('Los Angeles')[0],
            toCity: this.getObjectByCityName('Mexico City')[0]
          },
          {
            fromCity: this.getObjectByCityName('Los Angeles')[0],
            toCity: this.getObjectByCityName('San Francisco')[0]
          },
          {
            fromCity: this.getObjectByCityName('San Francisco')[0],
            toCity: this.getObjectByCityName('Chicago')[0]
          },
          {
            fromCity: this.getObjectByCityName('Chicago')[0],
            toCity: this.getObjectByCityName('Mexico City')[0]
          },
          {
            fromCity: this.getObjectByCityName('Chicago')[0],
            toCity: this.getObjectByCityName('Atlanta')[0]
          },
          {
            fromCity: this.getObjectByCityName('Chicago')[0],
            toCity: this.getObjectByCityName('Montreal')[0]
          },
          {
            fromCity: this.getObjectByCityName('Mexico City')[0],
            toCity: this.getObjectByCityName('Miami')[0]
          },
          {
            fromCity: this.getObjectByCityName('Mexico City')[0],
            toCity: this.getObjectByCityName('Bogota')[0]
          },
          {
            fromCity: this.getObjectByCityName('Mexico City')[0],
            toCity: this.getObjectByCityName('Lima')[0]
          },
          {
            fromCity: this.getObjectByCityName('Lima')[0],
            toCity: this.getObjectByCityName('Bogota')[0]
          },
          {
            fromCity: this.getObjectByCityName('Lima')[0],
            toCity: this.getObjectByCityName('Santiago')[0]
          },
          {
            fromCity: this.getObjectByCityName('Bogota')[0],
            toCity: this.getObjectByCityName('Buenos Aires')[0]
          },
          {
            fromCity: this.getObjectByCityName('Bogota')[0],
            toCity: this.getObjectByCityName('Sao Paulo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Bogota')[0],
            toCity: this.getObjectByCityName('Miami')[0]
          },
          {
            fromCity: this.getObjectByCityName('Miami')[0],
            toCity: this.getObjectByCityName('Atlanta')[0]
          },
          {
            fromCity: this.getObjectByCityName('Miami')[0],
            toCity: this.getObjectByCityName('Washington')[0]
          },
          {
            fromCity: this.getObjectByCityName('Atlanta')[0],
            toCity: this.getObjectByCityName('Washington')[0]
          },
          {
            fromCity: this.getObjectByCityName('Miami')[0],
            toCity: this.getObjectByCityName('Washington')[0]
          },
          {
            fromCity: this.getObjectByCityName('Montreal')[0],
            toCity: this.getObjectByCityName('New York')[0]
          },
          {
            fromCity: this.getObjectByCityName('Montreal')[0],
            toCity: this.getObjectByCityName('Washington')[0]
          },
          {
            fromCity: this.getObjectByCityName('Washington')[0],
            toCity: this.getObjectByCityName('New York')[0]
          },
          {
            fromCity: this.getObjectByCityName('London')[0],
            toCity: this.getObjectByCityName('New York')[0]
          },
          {
            fromCity: this.getObjectByCityName('Madrid')[0],
            toCity: this.getObjectByCityName('New York')[0]
          },
          {
            fromCity: this.getObjectByCityName('Sao Paulo')[0],
            toCity: this.getObjectByCityName('Lagos')[0]
          },
          {
            fromCity: this.getObjectByCityName('Sao Paulo')[0],
            toCity: this.getObjectByCityName('Madrid')[0]
          },
          {
            fromCity: this.getObjectByCityName('Sao Paulo')[0],
            toCity: this.getObjectByCityName('Buenos Aires')[0]
          },
          {
            fromCity: this.getObjectByCityName('Khartoum')[0],
            toCity: this.getObjectByCityName('Lagos')[0]
          },
          {
            fromCity: this.getObjectByCityName('Khartoum')[0],
            toCity: this.getObjectByCityName('Kinshasa')[0]
          },
          {
            fromCity: this.getObjectByCityName('Khartoum')[0],
            toCity: this.getObjectByCityName('Cairo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Kinshasa')[0],
            toCity: this.getObjectByCityName('Lagos')[0]
          },
          {
            fromCity: this.getObjectByCityName('Kinshasa')[0],
            toCity: this.getObjectByCityName('Johannesburg')[0]
          },
          {
            fromCity: this.getObjectByCityName('Khartoum')[0],
            toCity: this.getObjectByCityName('Johannesburg')[0]
          },
          {
            fromCity: this.getObjectByCityName('Riyadh')[0],
            toCity: this.getObjectByCityName('Cairo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Algiers')[0],
            toCity: this.getObjectByCityName('Cairo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Istanbul')[0],
            toCity: this.getObjectByCityName('Cairo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Baghdad')[0],
            toCity: this.getObjectByCityName('Cairo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Baghdad')[0],
            toCity: this.getObjectByCityName('Riyadh')[0]
          },
          {
            fromCity: this.getObjectByCityName('Baghdad')[0],
            toCity: this.getObjectByCityName('Karachi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Baghdad')[0],
            toCity: this.getObjectByCityName('Tehran')[0]
          },
          {
            fromCity: this.getObjectByCityName('Baghdad')[0],
            toCity: this.getObjectByCityName('Istanbul')[0]
          },
          {
            fromCity: this.getObjectByCityName('Milan')[0],
            toCity: this.getObjectByCityName('Istanbul')[0]
          },
          {
            fromCity: this.getObjectByCityName('Algiers')[0],
            toCity: this.getObjectByCityName('Istanbul')[0]
          },
          {
            fromCity: this.getObjectByCityName('Moscow')[0],
            toCity: this.getObjectByCityName('Istanbul')[0]
          },
          {
            fromCity: this.getObjectByCityName('St. Petersburg')[0],
            toCity: this.getObjectByCityName('Istanbul')[0]
          },
          {
            fromCity: this.getObjectByCityName('St. Petersburg')[0],
            toCity: this.getObjectByCityName('Moscow')[0]
          },
          {
            fromCity: this.getObjectByCityName('St. Petersburg')[0],
            toCity: this.getObjectByCityName('Essen')[0]
          },
          {
            fromCity: this.getObjectByCityName('London')[0],
            toCity: this.getObjectByCityName('Essen')[0]
          },
          {
            fromCity: this.getObjectByCityName('Paris')[0],
            toCity: this.getObjectByCityName('Essen')[0]
          },
          {
            fromCity: this.getObjectByCityName('Milan')[0],
            toCity: this.getObjectByCityName('Essen')[0]
          },
          {
            fromCity: this.getObjectByCityName('Paris')[0],
            toCity: this.getObjectByCityName('London')[0]
          },
          {
            fromCity: this.getObjectByCityName('Paris')[0],
            toCity: this.getObjectByCityName('Madrid')[0]
          },
          {
            fromCity: this.getObjectByCityName('Paris')[0],
            toCity: this.getObjectByCityName('Milan')[0]
          },
          {
            fromCity: this.getObjectByCityName('Paris')[0],
            toCity: this.getObjectByCityName('Algiers')[0]
          },
          {
            fromCity: this.getObjectByCityName('Tehran')[0],
            toCity: this.getObjectByCityName('Karachi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Delhi')[0],
            toCity: this.getObjectByCityName('Karachi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Mumbai')[0],
            toCity: this.getObjectByCityName('Karachi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Riyadh')[0],
            toCity: this.getObjectByCityName('Karachi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Tehran')[0],
            toCity: this.getObjectByCityName('Moscow')[0]
          },
          {
            fromCity: this.getObjectByCityName('Tehran')[0],
            toCity: this.getObjectByCityName('Delhi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Mumbai')[0],
            toCity: this.getObjectByCityName('Delhi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Chennai')[0],
            toCity: this.getObjectByCityName('Delhi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Kolkata')[0],
            toCity: this.getObjectByCityName('Delhi')[0]
          },
          {
            fromCity: this.getObjectByCityName('Kolkata')[0],
            toCity: this.getObjectByCityName('Chennai')[0]
          },
          {
            fromCity: this.getObjectByCityName('Kolkata')[0],
            toCity: this.getObjectByCityName('Bangkok')[0]
          },
          {
            fromCity: this.getObjectByCityName('Kolkata')[0],
            toCity: this.getObjectByCityName('Hong Kong')[0]
          },
          {
            fromCity: this.getObjectByCityName('Shanghai')[0],
            toCity: this.getObjectByCityName('Hong Kong')[0]
          },
          {
            fromCity: this.getObjectByCityName('Taipei')[0],
            toCity: this.getObjectByCityName('Hong Kong')[0]
          },
          {
            fromCity: this.getObjectByCityName('Bangkok')[0],
            toCity: this.getObjectByCityName('Hong Kong')[0]
          },
          {
            fromCity: this.getObjectByCityName('Ho Chi Minh City')[0],
            toCity: this.getObjectByCityName('Hong Kong')[0]
          },
          {
            fromCity: this.getObjectByCityName('Chennai')[0],
            toCity: this.getObjectByCityName('Jakarta')[0]
          },
          {
            fromCity: this.getObjectByCityName('Chennai')[0],
            toCity: this.getObjectByCityName('Bangkok')[0]
          },
          {
            fromCity: this.getObjectByCityName('Chennai')[0],
            toCity: this.getObjectByCityName('Mumbai')[0]
          },
          {
            fromCity: this.getObjectByCityName('Jakarta')[0],
            toCity: this.getObjectByCityName('Bangkok')[0]
          },
          {
            fromCity: this.getObjectByCityName('Jakarta')[0],
            toCity: this.getObjectByCityName('Ho Chi Minh City')[0]
          },
          {
            fromCity: this.getObjectByCityName('Jakarta')[0],
            toCity: this.getObjectByCityName('Sydney')[0]
          },
          {
            fromCity: this.getObjectByCityName('Manila')[0],
            toCity: this.getObjectByCityName('Sydney')[0]
          },
          {
            fromCity: this.getObjectByCityName('Manila')[0],
            toCity: this.getObjectByCityName('Ho Chi Minh City')[0]
          },
          {
            fromCity: this.getObjectByCityName('Manila')[0],
            toCity: this.getObjectByCityName('Taipei')[0]
          },
          {
            fromCity: this.getObjectByCityName('Osaka')[0],
            toCity: this.getObjectByCityName('Taipei')[0]
          },
          {
            fromCity: this.getObjectByCityName('Shanghai')[0],
            toCity: this.getObjectByCityName('Taipei')[0]
          },
          {
            fromCity: this.getObjectByCityName('Shanghai')[0],
            toCity: this.getObjectByCityName('Beijing')[0]
          },
          {
            fromCity: this.getObjectByCityName('Shanghai')[0],
            toCity: this.getObjectByCityName('Seoul')[0]
          },
          {
            fromCity: this.getObjectByCityName('Shanghai')[0],
            toCity: this.getObjectByCityName('Tokyo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Seoul')[0],
            toCity: this.getObjectByCityName('Beijing')[0]
          },
          {
            fromCity: this.getObjectByCityName('Seoul')[0],
            toCity: this.getObjectByCityName('Tokyo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Osaka')[0],
            toCity: this.getObjectByCityName('Tokyo')[0]
          },
          {
            fromCity: this.getObjectByCityName('Tokyo')[0],
            toCity: this.getObjectByCityName('To SF2')[0]
          },
          {
            fromCity: this.getObjectByCityName('Manila')[0],
            toCity: this.getObjectByCityName('To SF')[0]
          },
          {
            fromCity: this.getObjectByCityName('Sydney')[0],
            toCity: this.getObjectByCityName('To LA')[0]
          },
          {
            fromCity: this.getObjectByCityName('San Francisco')[0],
            toCity: this.getObjectByCityName('To Tokyo')[0]
          },
          {
            fromCity: this.getObjectByCityName('San Francisco')[0],
            toCity: this.getObjectByCityName('To Manila')[0]
          },
          {
            fromCity: this.getObjectByCityName('Los Angeles')[0],
            toCity: this.getObjectByCityName('To Sydney')[0]
          }
        ];
      this.handleResize();
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize);
    }
  }
</script>

<style lang="sass" scoped>
  @import "~compass-mixins"

  a
    cursor: pointer

  small
    font-size: 0.65em

  .pt-2
    padding-top: 15px

  .my-auto
    margin: auto

  .text-center
    text-align: center

  .infection-card
    background-color: mediumseagreen !important

  .overlay
    position: absolute
    top: 50%
    z-index: 1050
    left: 50%

  .mt-1
    margin-top: 8px !important

  .md-dialog
    z-index: 899
    margin: initial
    max-width: 200px
    position: fixed
    text-align: center

  .new-game
    max-width: 800px
    min-width: 600px

  .close-dialog
    position: absolute
    top: -5px
    right: -8px

  .game-buttons
    position: absolute
    top: 0
    left: 0
    width: 23%
    z-index: 5

  .cured
    position: absolute
    bottom: 8%
    left: 58%
    width: 20%
    z-index: 497

  .turn-button
    margin-top: -7px

  .player-profiles
    position: absolute
    width: 100%
    color: #fff
    margin-top: 25px
    padding: 0 20px

  .available-actions
    position: absolute
    bottom: 0
    left: 90%
    z-index: 597

  .moveable
    position: absolute
    z-index: 598
    cursor: pointer
    border: none

  .player
    display: block
    font-weight: bold
    background-color: transparentize(mediumseagreen, 0.2)

  .infection-rate
    position: absolute
    top: 7px
    left: 70%
    z-index: 498

  .rate
    z-index: 599

  .outbreaks
    position: absolute
    top: 55%
    left: 5%
    width: 7%
    z-index: 497

  .outbreaks-indicator
    z-index: 498

  .connecting-lines
    position: absolute
    top: 20px
    left: 0
    height: 100%
    width: 100%
    z-index: 1

  .line
    stroke: #cfd2e4
    stroke-width: 2px

  .eradicated
    background: none
    margin: 12px 0 0

  .card-in-hand
    padding: 0 3px

  .dialog-text
    display: inline
    padding-top: 4px

  .infection-button
    margin-top: -5px

  .flip-list-move
    transition: transform 0.5s

  .no-move
    transition: transform 0s

  .ghost
    opacity: 0.5
    background: #c8ebfb

  .list-group
    min-height: 20px

  .list-group-item
    cursor: move

  .list-group-item i
    cursor: pointer

  $color-background: rgb(26, 26, 26)
  $color-highlight: rgb(175, 225, 250)
  $color-highlight-light: lighten($color-highlight, 10%)
  $color-highlight-dark: darken($color-highlight, 10%)

  $color-foreground: invert($color-background)

  $map-dot-size: 2vw

  $transition-time: 0.25s

  html
    background: $color-background
    color: $color-foreground
    text-align: center

  body
    max-width: 1200px
    margin: 20px auto
    padding: 0 100px
    overflow-x: hidden

  .description
    max-width: 600px
    margin: 0 auto
    color: transparentize($color-foreground, 0.3)

  div, img, footer
    position: relative
    @include box-sizing(border-box)

  h1, h2, h3, h4, h5, h6
    margin-bottom: 20px
    text-transform: uppercase
    font-weight: 900
    color: #ffffff
    font-family: Oswald, sans-serif

  h1
    font-size: 46pt
    letter-spacing: 5px
    color: #ffffff

  h2
    font-size: 24pt

  h3
    font-size: 18pt

  h4
    font-size: 16pt
    margin-bottom: 0

  h5
    font-size: 14pt

  h6
    font-size: 12pt

  p
    font-size: 12pt
    margin-bottom: 12pt

  strong
    font-weight: 900
    color: $color-foreground

  a
    @include transition(color $transition-time ease-in-out)
    text-transform: uppercase
    text-decoration: none
    color: $color-highlight-light

    &:visited
      color: $color-highlight-light

    li.active &,
    &:hover,
    &:active
      color: $color-foreground

  .centered
    position: absolute
    top: 50%
    left: 50%
    @include translate(-50%, -50%)

  .centered-y
    position: absolute
    width: 100%
    top: 50%
    @include translateY(-50%)

  .distribution-map
    position: relative
    width: 100%
    padding: 20px
    @include box-sizing(border-box)
    margin: 0 auto

    > img
      width: 100%
      position: relative
      margin: 0
      padding: 0

    .map-point-4
      cursor: pointer
      outline: none
      z-index: 2
      position: absolute
      width: 2*$map-dot-size/3
      height: 2*$map-dot-size/3
      @include translate(-50%, -50%)
      @include transition(opacity $transition-time ease-in-out $transition-time, width $transition-time ease-in-out $transition-time, height $transition-time ease-in-out $transition-time, z-index $transition-time ease-in-out $transition-time)
      background: #099675
      border: solid 2px #000
      border: $map-dot-size/16 solid tranparent
      font-weight: bold
      margin-top: -2px

    .loc-top
      margin-top: -15px
      margin-left: 12px

    .loc-right
      margin-left: 25px

    .map-point
      cursor: pointer
      outline: none
      z-index: 597
      position: absolute
      width: $map-dot-size
      height: $map-dot-size
      @include border-radius($map-dot-size/2)
      @include opacity(0.8)
      @include translate(-50%, -50%)
      @include transition(opacity $transition-time ease-in-out $transition-time, width $transition-time ease-in-out $transition-time, height $transition-time ease-in-out $transition-time, z-index $transition-time ease-in-out $transition-time)
      background: transparentize($color-background, 0.15)
      border: $map-dot-size/8 solid transparent
      padding-top: $map-dot-size/2
      padding-left: 0
      font-weight: bold
      color: white


</style>